/** Une ou deux lettres : « u », « AB ». Rien d'autre ne s'écrit sous la flèche. */
export const NOM_DE_VECTEUR_FIGURE = /^[A-Za-z]{1,2}$/;
/** L'air réservé AU-DESSUS des lettres pour la flèche, en fraction de la taille du texte. */
export const AIR_FLECHE_NOM = 0.42;
/** La pointe de la flèche du nom, en unités d'affichage : longueur et demi-largeur. */
const POINTE_LONGUEUR = 4.2;
const POINTE_DEMI = 2.4;
/** Les lettres qui montent (capitales et hampes) : la flèche passe au-dessus d'elles. */
const MONTE = /[A-Zbdfhklt]/;
/**
 * Le centre de la boîte du nom (lettres ET flèche), pour une flèche de `a` à `b`
 * (coordonnées d'affichage). `ecartUnite` : 0,45 unité de figure, en unités
 * d'affichage ; `heurts(boite)` : combien de choses déjà posées la boîte touche.
 */
export function placerNomDeVecteurV2(a, b, largeur, hauteur, ecartUnite, heurts) {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    const n = Math.hypot(dx, dy);
    const u = n > 1e-9 ? { x: dx / n, y: dy / n } : { x: 1, y: 0 };
    /* À l'écran, y descend : la gauche du sens de la flèche est (u.y, −u.x). */
    const gauche = { x: u.y, y: -u.x };
    const droite = { x: -gauche.x, y: -gauche.y };
    const ecart = Math.max(3, ecartUnite - Math.min(largeur, hauteur) / 2);
    const decale = (p, d, e) => {
        const etendue = (Math.abs(d.x) * largeur) / 2 + (Math.abs(d.y) * hauteur) / 2;
        return { x: p.x + d.x * (e + etendue), y: p.y + d.y * (e + etendue) };
    };
    const le = (t) => ({ x: a.x + dx * t, y: a.y + dy * t });
    const places = [decale(le(0.5), gauche, ecart), decale(le(0.5), droite, ecart)];
    for (const t of [0.2, -0.2, 0.32, -0.32]) {
        places.push(decale(le(0.5 + t), gauche, ecart), decale(le(0.5 + t), droite, ecart));
    }
    /* En dernier recours, plus loin du trait. */
    places.push(decale(le(0.5), gauche, ecart + 0.3 * ecartUnite));
    places.push(decale(le(0.5), droite, ecart + 0.3 * ecartUnite));
    let choix = places[0];
    let min = Infinity;
    places.forEach((c, rang) => {
        /* Dix fois une collision pèse plus que tout l'ordre de préférence. */
        const cout = 10 * heurts({ x: c.x - largeur / 2, y: c.y - hauteur / 2, largeur, hauteur }) + rang / 100;
        if (cout < min - 1e-9) {
            min = cout;
            choix = c;
        }
    });
    return choix;
}
/**
 * La flèche au-dessus des lettres : le trait (du bord gauche au pied de la
 * pointe) et la pointe pleine. `centre` : le centre de la boîte entière ;
 * `ligneDeBase` : celle des lettres ; `taille` : la taille du texte.
 */
export function flecheDuNomV2(lettres, centre, largeurLettres, ligneDeBase, taille) {
    const hautDesLettres = (MONTE.test(lettres) ? 0.74 : 0.54) * taille;
    const y = ligneDeBase - hautDesLettres - 2.2;
    const x0 = centre.x - largeurLettres / 2 + 0.5;
    const x1 = centre.x + largeurLettres / 2 + 0.5;
    return {
        trait: [
            { x: x0, y },
            { x: x1 - POINTE_LONGUEUR + 0.6, y },
        ],
        pointe: [
            { x: x1, y },
            { x: x1 - POINTE_LONGUEUR, y: y - POINTE_DEMI },
            { x: x1 - POINTE_LONGUEUR, y: y + POINTE_DEMI },
        ],
    };
}
//# sourceMappingURL=nom-de-vecteur.js.map